import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b243b5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "supply" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.supplyTaskStatus?.task_status == _ctx.ConstantsType.supply_status_ing_1 ||
        _ctx.supplyTaskStatus?.task_status == _ctx.ConstantsType.supply_status_duijie_3
          ? _ctx.t("supplying")
          : _ctx.t("autosupplying")), 1),
    _hoisted_2,
    _createElementVNode("p", null, _toDisplayString(_ctx.t("starttime")) + "：" + _toDisplayString(_ctx.fromatDateYMDHMS(_ctx.supplyTaskStatus?.start_time)), 1),
    _hoisted_3,
    _createElementVNode("p", null, _toDisplayString(_ctx.t("station")) + "：" + _toDisplayString(_ctx.supplyTaskStatus?.name), 1),
    _hoisted_4,
    (_ctx.supplyTaskStatus?.supply_mode == '0')
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.t("supplymode")) + "：" + _toDisplayString(_ctx.t("fullsupply")), 1))
      : _createCommentVNode("", true),
    (_ctx.supplyTaskStatus?.supply_mode == '1')
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.t("supplymode")) + "：" + _toDisplayString(_ctx.t("chargeonly")), 1))
      : _createCommentVNode("", true)
  ]))
}